<template>
  <div class="form-edit-container">
    <div class="content">
      <left-panel
        ref="leftBorad"
        v-bind="{
          activeData,
          formConf: tempFormConf,
          formKey
        }"
        v-on="{
          'clone-component': cloneComponent,
          move: handleMove,
          end: onEnd,
          'add-component': addComponent,
          'scroll-to': scrollToItem,
          outlineEnd: onOutlineEnd,
          start: onStart,
          deleteManyProjectItem
        }"
      />
      <div class="center-board">
        <el-row class="operation-btn-view" type="flex" align="middle">
          <el-col :span="12" class="text-base-color small-font-size">
            * 表单内容自动保存
            <i :class="showLoading ? 'el-icon-loading' : 'el-icon-check'"></i>
          </el-col>
          <el-col :span="6" class="import-topic-box">
            <el-button icon="el-icon-refresh-left" type="text" @click="handleUndo"> 撤销 </el-button>
            <el-button icon="el-icon-top" type="text" @click="handleOpenImportItem"> 导入题目 </el-button>
          </el-col>
        </el-row>
        <ImportFormItem ref="importItems" :form-key="formKey" @success="handleConfirmImport" />
        <el-scrollbar ref="centerScrollbar" class="form-center-scrollbar">
          <center-panel
            ref="centerBorad"
            v-bind="centerProps"
            v-on="centerEvents"
            :activeId.sync="activeId"
            :drawingList.sync="drawingList"
            :activeGroupId.sync="activeGroupId"
            :currenGroupItem.sync="currenGroupItem"
            :operate.sync="operate"
          >
          </center-panel>
        </el-scrollbar>
      </div>
      <right-panel
        :active-data="activeData"
        :activeGroupId="activeGroupId"
        :form-conf="formConf"
        :fields="drawingList"
        :show-field="!!drawingList.length"
        :formKey="formKey"
        @tag-change="tagChange"
        @add-fields="handleAddFields"
        @data-change="handleActiveDataChange"
        @other-required-change="handleChangeRequired"
      />
    </div>

    <el-dialog class="create-form-dialog" :visible.sync="formItemExtensionVisible" @close="resetForm" width="35%">
      <div slot="title" class="dialog-title">
        <h2>选项后填空</h2>
        <span class="title_tips">在选项后设置填空，供答题者补充答题信息</span>
      </div>
      <div class="container">
        <el-table style="width: 100%" :data="extensionData">
          <el-table-column label="选项" prop="label"> </el-table-column>
          <el-table-column align="center">
            <template slot="header" slot-scope="scope">
              <span style="display: none">{{ scope.row }}</span>
              <el-checkbox v-model="isFillChecked" @change="(val) => handleClickRequire(val, 'isFill')">
                设置填空
              </el-checkbox>
            </template>
            <template slot-scope="{ row }">
              <div style="display: flex; line-height: 1">
                <el-checkbox
                  :disabled="row.value === 0"
                  v-model="row.isFill"
                  style="margin-right: 5px"
                  @change="resetOptionExtension(row.value)"
                ></el-checkbox>
                <div style="position: relative" v-if="row.isFill">
                  <span class="drawing-item__setting" title="选项后填空" @click="handleSetting(row.value)">
                    <i class="el-icon-setting" />
                    <span class="drawing-item__check" v-show="row.fillContent">
                      <i class="el-icon-check"></i>
                    </span>
                  </span>
                  填空内容可选择
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header" slot-scope="scope">
              <span style="display: none">{{ scope.row }}</span>
              <el-checkbox v-model="requiredChecked" @change="(val) => handleClickRequire(val, 'required')">
                是否必填
              </el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.required"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formItemExtensionVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="batchDialogVisible" width="30%">
      <div slot="title" class="dialog-title">
        <h2>填空内容可选择</h2>
        <span class="title_tips"
          >若想让答题者在可填空的输入框中进行下拉选择，可以在下方输入框中输入选项，一行一个。</span
        >
      </div>
      <span class="desc-text">每行对应一个选项</span>
      <el-input
        v-model="batchItemValue"
        type="textarea"
        :autosize="{ minRows: 10, maxRows: 5000 }"
        placeholder="选项1 选项2  选项3 "
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click=";(batchDialogVisible = false), (batchItemValue = '')">取 消</el-button>
        <el-button type="primary" @click="batchEditSelectItems">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FormItemLayout from './FormItemLayout'
import RightPanel from './RightPanel'
import LeftPanel from './LeftPanel'
import CenterPanel from './CenterPanel'
import ImportFormItem from './ImportFormItem'
import { debounce } from 'throttle-debounce'
import { getComponentsObj, getFormConfig } from '../GenerateForm/config'
import _ from 'lodash'
import '../../../assets/icons'
import { deepClone, jsonSimpleClone, removeHtmlTag } from '@/utils'
import { dbDataConvertForItemJson, formItemConvertData } from '@/utils/convert'
import {
  createProjectItem,
  queryProject,
  queryProjectItemList,
  sortProjectItem,
  stopPublishFormRequest,
  updateProjectItem,
  batchCreateProjectItem,
  getAllFormItemOptionsExtension,
  updateFormItemOptions,
  batchDeleteOutlineProject,
  undoFormApi
} from '../../../api/project/form'
import mixin from './mixin'

// let oldActiveId
let tempActiveData

export default {
  name: 'FormEditor',
  components: {
    FormItemLayout,
    draggable,
    RightPanel,
    LeftPanel,
    CenterPanel,
    ImportFormItem
  },
  mixins: [mixin],
  data() {
    return {
      showLoading: false,
      formConf: null,
      tempFormConf: {},
      labelWidth: 100,
      drawingList: [],
      activeId: 0,
      activeData: null,
      formKey: null,
      extensionData: [],
      formItemExtensionVisible: false,
      batchDialogVisible: false,
      batchItemValue: '',
      isFillChecked: false,
      requiredChecked: false,
      settingOptionId: '',
      activeGroupId: 0,
      currenGroupItem: {},
      canDrag: true,
      hoverIndex: 0,
      firstLoad: true, // 是否第一次进入页面，用于选中默认的题目组
      operate: '', // 记录当前做了什么操作
      oldData: { drawingList: [], onlineData: [] } // 备份拖拽开始前的原始数据
    }
  },
  computed: {
    centerProps() {
      return {
        activeData: this.activeData,
        formKey: this.formKey,
        formConf: this.formConf,
        fields: this.drawingList,
        showField: this.hasDrawingList
      }
    },
    hasDrawingList() {
      return this.drawingList.length > 0
    },
    centerEvents() {
      return {
        start: this.onStart,
        move: this.handleCenterMove,
        onItemEnd: this.onItemEnd,
        'tag-change': this.tagChange,
        'add-fields': this.handleAddFields,
        'other-required-change': this.handleChangeRequired,
        activeFormItem: this.activeFormItem,
        updateProjectItemInfo: this.updateProjectItemInfo,
        saveProjectItemInfo: this.saveProjectItemInfo,
        getOutLineList: this.getOutLineList,
        queryProjectItems: this.queryProjectItems,
        drawingItemAddInputItem: this.drawingItemAddInputItem,
        uploadImg: this.uploadImg,
        scrollToBottom: this.scrollToBottom,
        resetActiveFormItem: this.resetActiveFormItem
      }
    }
  },
  watch: {
    activeId: {
      handler(val) {
        console.log('选中某个组件' + val)
        // oldActiveId = val
        if (val) {
          // 选中当前题目组的题目时，把currenGroupItem也设置为当前题目的父级组
          const curGroup = this.drawingList.find((item) => item.formItemGroupId === this.activeData.formItemGroupId)
          if (curGroup) {
            this.currenGroupItem = curGroup
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 复制对象 避免修改改变原始对象
    this.formConf = JSON.parse(JSON.stringify(getFormConfig(this.$route.query.type)))
    // 项目key
    this.formKey = this.$route.query.key
    this.formConf.formKey = this.formKey
    // 从服务端获取

    this.queryProjectItems()
    this.queryProject()
  },
  methods: {
    // 获取表单配置
    queryProject() {
      queryProject(this.formKey).then((res) => {
        this.tempFormConf = res.data
        this.formConf.title = res.data.name
        this.formConf.type = res.data.type
        this.formConf.description = res.data.description
      })
    },
    // 处理已经发布的表单
    async handleCheckPublicForm() {
      let noPublish = true
      if (this.tempFormConf.status == 2) {
        noPublish = false
        await this.$confirm('该表单已发布，继续编辑将会停止发布，是否确认？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(async () => {
            await stopPublishFormRequest({ formKey: this.formKey })
            await this.queryProject()
            noPublish = true
          })
          .catch(() => {
            noPublish = false
          })
      }
      return noPublish
    },
    handleActiveDataChange(val) {
      // 特殊处理子表单 使修改的数据为子表单组件本身
      let copyValue = jsonSimpleClone(val)
      if (val.isChild) {
        let parentItem = val.parentItem
        let tempVal = deepClone(val)
        delete tempVal.parentItem
        delete tempVal.childIndex
        parentItem.childList[val.childIndex] = tempVal
        let tempParVal = jsonSimpleClone(parentItem)
        tempParVal.childList.forEach((item) => {
          delete item.parentItem
        })
        copyValue = tempParVal
      }
      this.updateProjectItemInfo(copyValue)
    },
    // 修改其他选项必填属性 要同步 选项扩展信息中的 选项必填
    handleChangeRequired(item) {
      this.activeData = item
      const itemIndex = this.drawingList.findIndex((drawItem) => drawItem.formItemId === item.formItemId)
      if (!itemIndex < 0) {
        this.$set(this.drawingList, itemIndex, item)
      }
    },
    updateProjectItemInfo: debounce(100, true, function (val) {
      this.showLoading = true
      const data = formItemConvertData(val, this.formKey)
      updateProjectItem(data)
        .then(() => {
          console.log('这是真正的保存')
          this.showLoading = false
          this.getOutLineList()
        })
        .catch(async () => {
          // 报错的话，还原数据
          await this.queryProjectItems()
          this.updateRightPanelViewData()
        })
    }),
    // 编辑页拖动、修改分组名、题目名等操作 同步更新大纲页
    getOutLineList() {
      if (!this.$refs.leftBorad) return
      const { currentTab, outlineData } = this.$refs.leftBorad
      if (currentTab === 'components') return // 此时不显示大纲页，不用执行更新操作
      this.$refs.leftBorad.getOutline()
      // const list = deepClone(this.drawingList)

      // // 提前构建 outLineDataMap 方便后续查找
      // const outLineDataMap = new Map(outlineData.map((group) => [group.formItemGroupId, group]))
      // const sortedOutlineData = list.reduce((result, { formItemGroupId, sort, name, items, ...group }) => {
      //   const matchingOutLineGroup = outLineDataMap.get(formItemGroupId)
      //     ? outLineDataMap.get(formItemGroupId)
      //     : { formItemGroupId, sort, name, items, ...group }

      //   result.push({
      //     ...matchingOutLineGroup,
      //     groupSort: sort,
      //     formItemGroupName: name,
      //     groupItems: items.map(({ formKey, dId, sort, config: { label } }) => ({
      //       formKey,
      //       id: dId,
      //       sort,
      //       title: removeHtmlTag(label)
      //     }))
      //   })

      //   return result
      // }, [])

      // this.$refs.leftBorad.outlineData = sortedOutlineData
    },
    // 批量删除组件
    async deleteManyProjectItem(list) {
      this.showLoading = true
      try {
        const { drawingList, formKey, $refs } = this // 解构 this，减少访问层级
        const leftBorad = $refs.leftBorad
        const { params } = drawingList.reduce(
          (acc, group) => {
            const deletedItems = group.items.filter((item) => list.includes(item.dId))
            // 只有在当前 group 中有删除项时，才转换格式
            if (deletedItems.length) {
              acc.params.push(...deletedItems.map((item) => formItemConvertData(item, formKey)))
            }
            return acc
          },
          { params: [] }
        )

        if (params.length === 0) {
          this.showLoading = false
          return // 没有需要删除的内容，直接返回
        }

        console.log('删除组件成功')
        await batchDeleteOutlineProject(params)
        await this.queryProjectItems()
        this.getOutLineList()

        if (leftBorad) {
          leftBorad.handleItemIds = []
        }
      } catch (error) {
        console.error('删除失败:', error)
      } finally {
        this.showLoading = false // 确保无论成功或失败都能重置 loading 状态
      }
    },

    async saveProjectItemInfo(item, needRefleshOutlineData = false) {
      this.showLoading = true
      let questionId = ''
      const params = formItemConvertData(item, this.formKey)
      const pItem = item
      try {
        const res = await createProjectItem(params)
        console.log('创建新的组件')
        pItem.sort = res.data.sort
        questionId = res.data.itemDataId
        await this.queryProjectItems()
        if (needRefleshOutlineData) this.getOutLineList()
      } catch (error) {
        console.error('创建失败:', error)
      } finally {
        this.showLoading = false // 确保无论成功或失败都能重置 loading 状态
      }
      // 如果是分页组件 刷新所有分页的页码
      if (item.typeId === 'PAGINATION') {
        this.updatePaginationList()
      }
      return questionId
    },
    updatePaginationList() {
      console.log('进入更新')
      // 页总数
      const { length } = this.drawingList.filter((item) => item.typeId === 'PAGINATION')
      let curr = 1
      this.drawingList.forEach((item, index) => {
        if (item.typeId === 'PAGINATION') {
          item.totalPageNum = length
          item.currPageNum = curr++
          this.$set(this.drawingList, index, item)
        }
      })
    },
    // 导入题目
    async handleConfirmImport(itemList) {
      const importData = itemList.map((item) => ({ ...item, formItemGroupId: this.currenGroupItem.formItemGroupId }))

      await batchCreateProjectItem(importData)
      this.msgSuccess('保存成功')
      this.$refs.importItems.hiddenDialog()
      await this.queryProjectItems()
      this.getOutLineList()
    },
    // 获取已经配置的表单项
    async queryProjectItems(resolve) {
      const { formKey } = this
      const [res, formData] = await Promise.all([
        getAllFormItemOptionsExtension(formKey),
        queryProjectItemList({ key: formKey })
      ])

      // 关于collapsed这个属性，就是折叠开关
      // 这里可以收集没更新前，旧的drawingList数据的collapsed，然后再赋值给新返回的数据，就完美解决了
      const oldDrawingList = this.drawingList.map((el) => {
        return {
          id: el.id,
          formKey: el.formKey,
          formItemGroupId: el.formItemGroupId,
          collapsed: el.collapsed
        }
      })

      // 更新后的数据
      this.drawingList = formData.data.map((group) => {
        const oldTarget = oldDrawingList.find(
          (el2) => el2.id === group.id && el2.formItemGroupId === group.formItemGroupId
        )
        return {
          ...group,
          collapsed: oldTarget ? oldTarget.collapsed : true,
          items: group.items.map((item) =>
            dbDataConvertForItemJson(item, res.data[item.formItemId] || [], group.formItemGroupId)
          )
        }
      })

      // 默认选中第一个题目组，只有第一次进入页面需要
      if (this.firstLoad) {
        const firstGroup = this.drawingList[0] || {}
        this.activeGroupId = firstGroup.id || ''
        this.currenGroupItem = firstGroup
        this.firstLoad = false // 进来之后把这个值改为false后续就不会一直第一个
      }

      await this.$nextTick()

      // 如果当前操作为新增题目，那么就自动，选中该项属性并滚动到对应项
      if (this.operate === 'addComponentItem') {
        let index = this.drawingList.findIndex((item) => item.id === this.currenGroupItem.id)
        const target = this.drawingList[index].items[this.drawingList[index].items.length - 1]
        if (target) {
          this.activeFormItem(target)
          this.scrollToItem(target.dId, 'dId')
        }
      }
      // 如果当前操作为新增题目组，那么就自动，选中该题目组并滚动到对应项
      if (this.operate === 'addComponentGroup') {
        // 先把旧的题目组数组的id筛选出来，然后再从新的里面过滤掉没有的，就是新增的
        const oldIds = oldDrawingList.map((el) => el.id)
        const targetGroup = this.drawingList.find((item) => !oldIds.includes(item.id))
        if (targetGroup) {
          this.activeGroupId = targetGroup.id || ''
          this.currenGroupItem = targetGroup
          this.scrollToItem(targetGroup.formItemGroupId, 'formItemGroupId')
        }
      }

      // 更新分页
      this.updatePaginationList()

      if (resolve) resolve()
    },
    // 选中当前item事件
    activeFormItem(currentItem) {
      this.activeData = currentItem
      this.$refs.leftBorad.selectItem = currentItem.dId
      this.activeId = currentItem.config.formId
    },
    // 重置右侧数据
    resetActiveFormItem() {
      this.activeData = null
      this.$refs.leftBorad.selectItem = 0
      this.activeId = 0
    },
    onStart() {
      // 禁用文本选择
      console.log('----开始拖拽')
      this.oldData = {
        drawingList: deepClone(this.drawingList),
        onlineData: deepClone(this.$refs.leftBorad?.outlineData || [])
      }
      document.body.style.userSelect = 'none'
      if (!this.canDrag) return
    },
    moveEnd() {
      // 恢复文本选择
      document.body.style.userSelect = 'auto'
    },
    handleMove(event) {
      // if (this.tempFormConf.status == 2) {
      //   this.handleCheckPublicForm()
      //   return false
      // }

      // 目标位置的索引
      const newIndex = event.relatedContext.index
      this.hoverIndex = newIndex
      return true
    },
    onEnd(obj) {
      if (obj.from === obj.to) return
      const { currenGroupItem } = this
      tempActiveData.formItemGroupId = obj.to.id
      this.activeData = tempActiveData
      this.activeId = `${_.toLower(tempActiveData.typeId)}-${new Date().getTime()}`
      // 拖拽到子表单不单独保存
      if (obj.to.className === 'list-main') {
        return
      }

      currenGroupItem.items.splice(obj.newIndex, 0, tempActiveData)

      this.saveProjectItemInfo(tempActiveData).then((id) => {
        obj.clone.id = id
        this.onItemEnd(obj)
      })
    },
    async onOutlineEnd(obj) {
      const { oldIndex, newIndex, clone, to, from } = obj
      const curOutLineItemId = clone.id.replace('outline_question_', '')
      const curOutLineGroupId = to.id.replace('outline_question_', '')

      if (oldIndex === newIndex && from.id === to.id) {
        this.$refs.leftBorad.selectItem = curOutLineItemId
        this.scrollToItem(curOutLineItemId, 'dId')
        return
      }

      const allQuestions = this.drawingList.reduce((acc, group) => acc.concat(group.items), [])
      const cueMoveItem = allQuestions.find((item) => item.dId === Number(curOutLineItemId))

      if (!cueMoveItem) {
        console.warn(`未找到题目 ID：${curOutLineItemId}`)
        return
      }

      const params = {
        formKey: this.formKey,
        afterMoveFormItemGroupId: curOutLineGroupId, // 移动后的题目组
        newIndex, // 移动后的新位置
        formItemId: cueMoveItem.config.formId
      }

      try {
        this.showLoading = true
        await sortProjectItem(params)
        // **确保 queryProjectItems 完全执行后再滚动**
        await this.queryProjectItems()
        this.getOutLineList()
        // 等待 DOM 更新后再执行滚动，确保元素已渲染
        this.$nextTick(() => {
          this.scrollToItem(curOutLineItemId, 'dId')
        })
      } catch (error) {
        console.error('移动题目失败:', error, this.oldDrawingList)
        this.handleSetData()
      } finally {
        this.showLoading = false
        this.moveEnd()
      }
    },
    handleSetData() {
      const { drawingList, onlineData } = this.oldData
      this.drawingList = deepClone(drawingList)
      this.$refs.leftBorad.outlineData = deepClone(onlineData)
      this.$forceUpdate()
    },
    // 大纲题目点击后自动表单自动定位
    scrollToItem(itemId, idKey) {
      const target = document.getElementById(itemId) // 获取目标元素
      const scrollbarWrap = this.$refs.centerScrollbar.$refs.wrap
      if (!target || !scrollbarWrap) return
      this.$nextTick(() => {
        const targetRect = target.getBoundingClientRect() // 获取目标元素相对视口的位置
        const scrollRect = scrollbarWrap.getBoundingClientRect() // 获取 el-scrollbar 容器的位置信息
        // 计算目标元素在 el-scrollbar 中的偏移量
        const offsetTopInScroll = targetRect.top - scrollRect.top
        const scrollOffset = scrollbarWrap.scrollTop + offsetTopInScroll
        // 让移动元素居中
        const centerOffset = scrollOffset - scrollbarWrap.clientHeight / 2 + target.offsetHeight / 2

        // 点击分组 要定位到顶部 scrollOffset - 100，点击题目则需居中显示 centerOffset
        scrollbarWrap.scrollTo({
          top: Math.max(0, idKey === 'dId' ? centerOffset : scrollOffset - 100),
          behavior: 'smooth'
        })
      })
      // // 设置选中组件
      const outLineActItem = this.findItemById(itemId, idKey)
      if (itemId === 'description') {
        this.$refs.centerBorad?.focusDescription() // 点击开始语自动focus
      } else if (idKey === 'dId') {
        if (outLineActItem) {
          this.activeFormItem(outLineActItem)
        }
      } else if (outLineActItem) {
        this.currenGroupItem = outLineActItem
        this.activeGroupId = outLineActItem.id
        this.activeId = 0
        this.activeData = null
      }
    },
    // 查找组件项的方法
    findItemById(itemId, idKey) {
      if (idKey === 'dId') {
        // 查找所有题目（跨分组）
        return this.drawingList.flatMap((group) => group.items).find((item) => item[idKey] === Number(itemId))
      }
      // 查找分组
      return this.drawingList.find((group) => group[idKey] === itemId)
    },
    handleCenterMove(obj) {
      // 不允许拖到子表单
      if (obj.to.className === 'list-main') {
        return false
      }
    },
    async onItemEnd(obj) {
      const allQuestions = this.drawingList.reduce((acc, group) => acc.concat(group.items), [])

      this.showLoading = true
      if (obj.oldIndex === obj.newIndex && obj.from.id === obj.to.id) {
        this.showLoading = false
        return
      }
      const { formKey } = this
      const params = { formKey }
      params.afterMoveFormItemGroupId = obj.to.id // 移动后的题目组
      params.newIndex = obj.newIndex // 移动题目的新位置
      const cueMoveItem = allQuestions.find((item) => item.dId === Number(obj.clone.id))
      params.formItemId = cueMoveItem.config.formId
      try {
        this.showLoading = true
        await sortProjectItem(params)
        // 排序之后要调用列表接口 刷新
        await this.queryProjectItems()
        this.getOutLineList()
      } catch (error) {
        console.error('移动题目失败:', error, this.oldDrawingList)
        this.handleSetData()
      } finally {
        this.showLoading = false
        this.moveEnd()
      }
    },
    // 添加组件题目
    async addComponent(item) {
      // 设置当前操作为新增题目项
      this.operate = 'addComponentItem'

      // const { drawingList, currenGroupItem } = this
      const clone = this.cloneComponent(item)

      clone.formItemGroupId = this.currenGroupItem.formItemGroupId
      this.saveProjectItemInfo(clone)
      // let index = drawingList.findIndex((item) => item.id === currenGroupItem.id)

      // drawingList[index].items.push(clone)
      // this.activeFormItem(clone)
      // this.scrollToItem(currenGroupItem.formItemGroupId, 'formItemGroupId')
    },
    scrollToBottom() {
      const div = this.$refs.centerScrollbar.$refs.wrap
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight
      })
    },
    cloneComponent(origin) {
      const clone = deepClone(origin)
      const config = clone.config
      this.createIdAndKey(clone)
      // 文件上传组件处理
      if (clone.action) {
        clone.action += this.formKey
      }
      clone.placeholder !== undefined && (clone.placeholder += config.label)
      tempActiveData = clone
      return tempActiveData
    },

    empty() {
      this.$confirm('确定要清空所有组件吗？', '提示', { type: 'warning' }).then(() => {
        this.drawingList = []
      })
    },
    drawingItemAddInputItem(cur) {
      this.activeFormItem(cur)
      this.extensionData = deepClone(cur.config.options)
      this.formItemExtensionVisible = true
    },
    // 题目选项后附图上传
    uploadImg(item) {
      const curGroupIndex = this.drawingList.findIndex((group) => group.formItemGroupId === item.formItemGroupId)
      if (curGroupIndex === -1) return // 如果找不到组，直接返回
      // 生成新的 items 数组，确保 Vue 能检测到变化
      const updatedItems = this.drawingList[curGroupIndex].items.map((drawItem) =>
        drawItem.formItemId === item.formItemId ? { ...item } : drawItem
      )
      this.$set(this.drawingList[curGroupIndex], 'items', updatedItems)
      this.activeFormItem(item)
      this.updateProjectItemInfo(item)
    },
    resetForm() {
      this.extensionData = []
      this.formItemExtensionVisible = false
      this.isFillChecked = false
      this.requiredChecked = false
      this.batchItemValue = ''
    },
    resetOptionExtension(val) {
      const _data = this.extensionData.map((item) => {
        if (item.value === val) {
          item.fillContent = null
          item.fillContentJson = null
        }
        return item
      })
      this.extensionData = _data
    },
    // 是否必填全选/取消全选
    handleClickRequire(val, key) {
      const _data = this.extensionData.map((item) => {
        if (item.value === 0 && key === 'isFill') console.log('---其他选项不修改')
        else {
          item[key] = val
        }
        if (!val && key === 'isFill' && item.value !== 0) {
          item.fillContent = null
          item.fillContentJson = null
        }
        return item
      })
      this.extensionData = _data
    },
    handleSetting(val) {
      this.settingOptionId = val
      this.batchItemValue = this.extensionData.filter((item) => item.value === val)[0].fillContent || ''
      this.batchDialogVisible = true
    },
    batchEditSelectItems() {
      const curForm = this.extensionData.find((item) => item.value === this.settingOptionId)
      if (curForm) {
        curForm.fillContent = this.batchItemValue
        curForm.fillContentJson = this.batchItemValue.split('\n').map((item, index) => {
          item = { value: index, label: item }
          return item
        })
      }
      this.batchDialogVisible = false
    },
    handleSubmit() {
      const { activeData, extensionData } = this
      updateFormItemOptions(extensionData).then((res) => {
        // const curDrawObjIndex = drawingList.findIndex((item) => item.formItemId === settingOptionId)
        // if (curDrawObjIndex != -1) {
        //   this.$set(this.drawingList, curDrawObjIndex, drawingList[curDrawObjIndex])
        // }
        const otherItem = extensionData.find((item) => item.value === 0)
        if (otherItem) {
          this.$set(this.activeData.config, 'otherRequired', otherItem.required)
        }
        if (activeData) {
          this.$set(this.activeData.config, 'options', extensionData)
        }

        this.$message.success('添加成功')
        this.formItemExtensionVisible = false
      })
    },

    // 类型切换 弃用
    tagChange(newTag) {
      newTag = this.cloneComponent(newTag)
      const config = newTag.config
      newTag.vModel = this.activeData.vModel
      newTag.sort = this.activeData.sort
      config.formId = this.activeId
      config.span = this.activeData.config.span
      this.activeData.config.tag = config.tag
      this.activeData.config.tagIcon = config.tagIcon
      this.activeData.config.document = config.document
      this.activeData.typeId = newTag.typeId
      if (typeof this.activeData.config.defaultValue === typeof config.defaultValue) {
        config.defaultValue = this.activeData.config.defaultValue
      }
      Object.keys(newTag).forEach((key) => {
        if (this.activeData[key] !== undefined) {
          newTag[key] = this.activeData[key]
        }
      })
      this.activeData = newTag
      this.updateProjectItemInfo(newTag)
      this.updateDrawingList(newTag, this.drawingList)
    },
    updateDrawingList(newTag, list) {
      const index = list.findIndex((item) => item.config.formId === this.activeId)
      if (index > -1) {
        list.splice(index, 1, newTag)
      } else {
        list.forEach((item) => {
          if (Array.isArray(item.config.children)) this.updateDrawingList(newTag, item.config.children)
        })
      }
    },
    handleOpenImportItem() {
      this.$refs.importItems.showDialog()
    },
    // 创建Ocr识别所需要的存储字段 由Ocr字段抛出
    handleAddFields(val) {
      //创建字段 保存识别返回字段和表单字段映射关系
      let fieldMapping = {}
      _.keys(val).forEach((key) => {
        let field = val[key]
        let compo = jsonSimpleClone(getComponentsObj()[field.type])
        compo.config.label = field.label
        const clone = this.cloneComponent(compo)
        this.saveProjectItemInfo(clone)
        this.drawingList.push(clone)
        console.log('复制一个组件')
        fieldMapping[key] = clone.config.formId
      })
      this.activeData.fieldMapping = fieldMapping
      // 保存
      this.handleActiveDataChange(this.activeData)
    },
    // 撤销操作
    handleUndo() {
      this.showLoading = true
      undoFormApi(this.formKey)
        .then(async () => {
          console.log('撤销表单')
          this.$refs.leftBorad?.getOutline()
          await this.queryProjectItems()
          this.updateRightPanelViewData()
        })
        .finally(() => {
          this.showLoading = false
        })
    },
    // 更新右侧属性面板，并且不触发更新
    updateRightPanelViewData() {
      if (!this.activeId) return
      // 要等新数据回来后才更新
      // 找出当前正在编辑右侧属性的item，并更新数据
      let target = null
      for (let i = 0; i < this.drawingList.length; i++) {
        const el = this.drawingList[i]
        if (el.items) {
          // 这是新的题目组的数据结构，通过这字段判断
          for (let j = 0; j < el.items.length; j++) {
            const el2 = el.items[j]
            if (el2.formItemId === this.activeId) {
              target = el2
              break
            }
          }
        } else {
          // 这里是旧的数据，作兼容
          if (el.formItemId === this.activeId) {
            target = el
          }
        }
        // 找到对应目标后就跳出循环
        if (target) break
      }

      if (target) {
        // 先重置再设置，不然会触发watch的自动更新
        this.resetActiveFormItem()
        // 这里等待一下刷新，不然vue会缓存组件不会删除
        this.$nextTick(() => {
          this.activeFormItem(target)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/styles/form/home.scss';
@import '../../../assets/styles/form/index.scss';
.hide-tinymce .el-textarea__inner {
  border: none;
  resize: none;
}
.title_tips {
  font-size: 12px;
  color: #9b9b9b;
}
.drawing-item__setting {
  font-size: 16px;
  display: inline-block;
  margin-right: 5px;
}
.drawing-item__check {
  position: absolute;
  font-size: 5px;
  background: #5dc976;
  color: #fff;
  width: 7px;
  height: 7px;
  line-height: 7px;
  border-radius: 50%;
  left: 10px;
  bottom: 1px;
}
.placeholder_box {
  width: 100%;
  height: 260px;
}
</style>
